import { render, staticRenderFns } from "./btns.vue?vue&type=template&id=34e0354f"
import script from "./btns.vue?vue&type=script&lang=js"
export * from "./btns.vue?vue&type=script&lang=js"
import style0 from "./btns.vue?vue&type=style&index=0&id=34e0354f&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports